import type {
  ConfigFormData,
  ToolchainData,
} from 'shared/types/configuration-service';
//
// const envvarsDefaults = (envvars: object) => {
//   const envvarArray = [];
//
//   for (const [key, value] of Object.entries(envvars)) {
//     envvarArray.push({
//       name: key,
//       value: value.default,
//       isSecret: value.type === 'Secret',
//     });
//   }
//   return envvarArray;
// };

export const setDefaultValues = (
  toolchainData: ToolchainData,
  environment: string,
  toolChainName: string
): ConfigFormData => {
  return Object.entries(toolchainData).reduce(
    (acc: { [key: string]: any }, [section, fieldNames]) => {
      // if (section === 'envvars') {
      //   acc[section] = envvarsDefaults(fieldNames ?? {});
      //   return acc;
      // }
      acc[section] = {
        ...acc[section],
        ...Object.entries(fieldNames ?? {}).reduce(
          (fieldAcc: { [key: string]: {} }, [fieldName, values]) => {
            // check for  values.type : 'Bool', 'Map'
            switch (values.type) {
              case 'Bool':
                fieldAcc[fieldName] = JSON.parse(values.default);
                break;
              case 'Map':
                {
                  const [key, value] = values.default.split(': ');
                  fieldAcc[fieldName] = {
                    [key]: value,
                  };
                }
                break;
              default:
                if (section === 'meta' && fieldName === 'version')
                  fieldAcc.toolchain = {
                    ...acc[section].toolchain,
                    [fieldName]: values.default,
                  };
                else fieldAcc[fieldName] = values.default;
                break;
            }

            return fieldAcc;
          },
          {}
        ),
      };
      return acc;
    },
    { meta: { environment, toolchain: { name: toolChainName } } }
  );
};
